import React, { useState, useEffect } from "react";
import localConfig from "../localConfig.json";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

function Chart(props) {
  const [data, setData] = useState({ events: [] });

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios({
        method: "get",
        url:
          "https://" +
          localConfig.SERVICE.URL +
          ":" +
          localConfig.SERVICE.PORT +
          `/api/dashboard/events/` +
          props.presenterId + `/null/null`,
        withCredentials: true,
        params: {},
      });
      setData(result.data);
    };
    fetchData();
  }, [props.presenterId]);
  
  return (
    <div>
      <BarChart
        width={900}
        height={450}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar name="Total events" dataKey="ev" fill="#564f4b" />
        <Bar name="Registration site" dataKey="rg" fill="#a0a1a3" />
        <Bar name="New organization" dataKey="nw" fill="#a36728" />
        <Bar name="Elected official" dataKey="el" fill="#f3aa1c" />
      </BarChart>
    </div>
  );
}

export default Chart;
